<template>
  <div
    class="chat-binary chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    <p v-if="message.DATA_TEXT">{{ message.DATA_TEXT }}</p>
    <img :src="imageUrl" alt="image" v-if="imageUrl" />
  </div>
</template>

<script>
// import axios from 'axios';
import MessageDate from '../MessageDate.vue';

export default {
  name: 'BinaryItem',
  props: ['message', 'token'],
  data() {
    return {
      imageUrl: null,
    };
  },
  components: {
    MessageDate,
  },
  beforeMount() {
    this.imageUrl = `${process.env.VUE_APP_API_URL}/msg/assistance/incident/${this.token}/binary/${this.message.ELEMENT_ID}`;
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  max-width: 100%;
  border-radius: $default-radius;
  display: block;
}
</style>
